import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEraserSimple"><Path d="M6.50011 9.43945L14.2501 1.68945L22.3108 9.75011L14.5608 17.5001L6.50011 9.43945Z" fill="currentColor"/><Path d="M5.43945 10.5001L1.68945 14.2501L9.75011 22.3108L13.5001 18.5608L5.43945 10.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
